import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App)

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
app.use(ElementPlus)

import june from './core/main'
import md5 from 'js-md5'

import Dialog from './components/Dialog'
import MarkdownViewer from './components/MarkdownViewer'
import DialogForm from './components/DialogForm'
import DialogTable from './components/DialogTable'
import DataTable from './components/DataTable'
import DataForm from './components/DataForm'
import CodeEditor from './components/CodeEditor'
import AiHelper from './components/AiHelper'
import ManageStyle from './layout/ManageStyle'
import AiChat from './components/AiChat/index';

app.component('Dialog', Dialog)
app.component('MarkdownViewer', MarkdownViewer)
app.component('DialogForm', DialogForm)
app.component('DialogTable', DialogTable)
app.component('DataTable', DataTable)
app.component('DataForm', DataForm)
app.component('ManageStyle', ManageStyle)
app.component('CodeEditor', CodeEditor)
app.component('AiHelper', AiHelper)
app.component('AiChat', AiChat)

app.config.globalProperties.$auth = june.auth
app.config.globalProperties.$router = june.router
app.config.globalProperties.$caches = june.caches
app.config.globalProperties.$md5 = md5

import config from './config'
import utils from './core/utils'
import bus from './core/bus'
import { request, upload } from './core/request'
import local from './core/local'

app.config.globalProperties.$config = config
app.config.globalProperties.$request = request
app.config.globalProperties.$upload = upload
app.config.globalProperties.$utils = utils
app.config.globalProperties.$bus = bus
app.config.globalProperties.$local = local

app.config.productionTip = false

// font-awsome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas, far, fab)

app.component('font-awesome-icon', FontAwesomeIcon)

// 引入代码编辑器
import VueCodeMirror from 'vue-codemirror';
app.use(VueCodeMirror);

Date.prototype.format = function(fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      try {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      } catch (e) {
        console.log(e)
      }
    }
  }
  return fmt
}

app.mount('#app')